<template>
  <aside class="side-nav large" :class="{active:sideNavActive}" ref="sidenav">
    <div class="side-nav__type-navigation side-nav__thumbnail" ref="sidenavchild">
      <div class="flex side-nav__types">
        <div class="side-nav__type"
             @click="selected_type=type.key"
             :class="{active:selected_type===type.key}"
             v-for="(type, typeKey) in isType">
          <a href="#">{{ type.title }}</a>
        </div>
      </div>
      <div class="side-nav__type">
        <div v-for="item in items" :key="item.code">
          <template v-if="getType(item) === selected_type">
            <router-link :to="{ name:'Section',
            params:{ code:item.code,title:item.title, type:selected_type, number:item.id} }">
              <div class="side-nav__thumbnail-picture">
                <div class="side-nav__thumbnail-picture--hover">
                  <img :src="'img/aside-arrow@0,5x.svg'">
                </div>
                <div class="side-nav__thumbnail-picture--clicked">
                  {{ $route.params.code }}
                </div>
                <picture :key="item.code">
                  <source media="(max-width: 667px)"
                          :srcset="`${path_thumbnail}/${item.code}@0,5x.jpg`">
                  <img :src="`${path_thumbnail}/${item.code}.jpg`">
                </picture>
              </div>
            </router-link>
            <div class="side-nav__thumbnail-title">{{ item.title }}</div>
          </template>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import TweenMax from "gsap";

export default {
  name: "side-nav",
  created() {
    this.items = this.$appData.filter(item => +item.id === +this.number);
  },
  mounted() {
    this.setAsideHeight()
  },
  data() {
    return {
      path_thumbnail: this.$appConfig.path.thumbnail,
      path_picture: this.$appConfig.path.picture,
      items: '',
      counter: {number: 0},
      types: this.$appConfig.type,
      selected_type: this.type
    }
  },
  methods: {
    startCounter() {
      TweenMax.set(this.counter, {delay: 1, number: 0});
      TweenMax.to(this.counter, 1, {
        delay: .15,
        roundProps: ['number'],
        number: this.number,
        ease: Power4.easeOut
      });
    },
    getType(item) {
      const [type] = Object.keys(item.type)
      if (!type) {
        return false
      }
      return type;
    },
    setAsideHeight() {
      const aside = this.$refs.sidenav;
      const asideChild = this.$refs.sidenavchild;
      const parent = aside.parentNode
      this.$nextTick(() => {
        if (asideChild.offsetHeight > aside.offsetHeight) {
          aside.classList.add('scroll')
        } else {
          aside.classList.remove('scroll')
        }
      })
    },
  },
  props: {
    number: {type: Number},
    type: {
      type: String,
      default: 'AF'
    },
    sideNavActive: {type: Boolean | Number},
    isMobile: {type: Boolean}
  },
  computed: {
    isType() {
      const checker = []
      this.items.forEach(({type}) => {
        const [key] = Object.keys(type);
        checker.push(key)
      })
      if (checker.some(item => item === 'AF') && checker.some(item => item === 'WF')) {
        return this.types
      } else {
        const [type] = checker
        if (type) {
          return this.types.filter(({key}) => key === type)
        }
      }
    }
  },
  watch: {
    number(val) {
      this.setAsideHeight()
      if (val) {
        let _this = this;
        _this.items = _this.$appData.filter(item => +item.id === +val);
        _this.startCounter();
      }
    }
  }
}
</script>